<ion-content [scrollY]="false" class="upload-confirm-content">
  <div class="modal-wrapper">
    <!-- Header row: title on the left, close on the right -->
    <div class="modal-header-row">
      <h2 class="modal-title">{{ 'upload_images' | translate }}</h2>
      <img class="close-icon" [tooltip]="'Close' | translate" alt="" placement="bottom"
           tabindex="0" role="button"
           (click)="onClose()" (keydown.enter)="onClose()"
           src="assets/icon/cancel.svg">
    </div>

    <!-- Success message -->
    <p class="success-message">{{ successMessage }}</p>

    <!-- Progress bar -->
    <div class="progress-bar-track">
      <div class="progress-bar-fill" [style.width]="progressWidth"></div>
    </div>

    <!-- Prompt text -->
    <p class="prompt-text">{{ 'upload_or_open_in_editor' | translate }}</p>

    <!-- Action buttons -->
    <div class="button-row">
      <ion-button
        class="btn-upload"
        expand="block"
        shape="round"
        (click)="onUploadDirectly()">
        {{ 'upload_directly' | translate }}
      </ion-button>
      <ion-button
        class="btn-edit"
        expand="block"
        shape="round"
        fill="outline"
        (click)="onEditImages()">
        {{ 'edit_images' | translate }}
      </ion-button>
    </div>
  </div>
</ion-content>
